import { useState, useRef, useEffect } from 'react';
import Marks from './marks';

const DiamondGame = ({user,gamePlayedUpdateDatabase,loading, setPlayAnimation}) => {
  const lineRef = useRef(null);
  const requestRef = useRef();
  const [position, setPosition] = useState(0);
  const direction = useRef(1);
  const [isPlaying, setIsPlaying] = useState(false);
  // const [result, setResult] = useState('Click "Start" to begin.');
  
  const areaWidth = 300;
  const centerX = areaWidth / 2;
  const speed = 4;

  const animate = () => {
    setPosition(prev => {
      let next = prev + direction.current * speed;
      if (next <= 0 || next >= areaWidth-speed) {
        direction.current = direction.current*-1;
        next = Math.max(0, Math.min(areaWidth-speed, next));
      }
      if (lineRef.current) {
        lineRef.current.style.left = `${next}px`;
      }
      return next;
    });

    requestRef.current = requestAnimationFrame(animate);
  };

  const startGame = () => {
    cancelAnimationFrame(requestRef.current);
    // setResult('Click inside the box to stop the line!');
    setPosition(0);
    direction.current=1;
    setIsPlaying(true);
    requestRef.current = requestAnimationFrame(animate);
  };

  const stopGame = () => {
    cancelAnimationFrame(requestRef.current);
    setIsPlaying(false);
    const distance = Math.abs(position - centerX);
    const score = Math.max(0, Math.round(100 - (distance / centerX) * 100));
    if(score >= 90) {
      gamePlayedUpdateDatabase(5, position)
    }
    else if(score >= 50) {
      gamePlayedUpdateDatabase(2, position)
    } 
    else {
      gamePlayedUpdateDatabase(1, position)
    }
    // setResult(`Stopped at ${Math.round(position)}px. Distance from center: ${Math.round(distance)}px. Score: ${score}/100`);
    setPlayAnimation(true);
  };

  useEffect(() => {
    if(user && user.hasPressedToday && user.attackPosition !== null) {
      setPosition(user.attackPosition)
    }
  }, [user])

  useEffect(() => {
    return () => cancelAnimationFrame(requestRef.current);
  }, []);

  return (
    <div style={{ textAlign: 'center'}}>

      <div
        id="gameArea"
        style={{
          position: 'relative',
          width: `${areaWidth}px`,
          height: '70px',
          margin: '0 auto',
          border: '5px solid #333',
          backgroundColor: '#f4f4f4',
          boxSizing: "content-box"
        }}
        onClick={() => isPlaying && stopGame()}
      >
        <Marks />
        <div
          ref={lineRef}
          id="line"
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            width: '4px',
            backgroundColor: 'red',
            left: `${position}px`
          }}
        ></div>
      </div>


      {!loading && user && !user.hasPressedToday && <button
        onClick={isPlaying ? stopGame : startGame}
        style={{
          marginTop: '15px',
          padding: '10px 25px',
          fontSize: '18px',
          cursor: 'pointer',
          width: `${areaWidth}px`
        }}
      >
        Attack
      </button> }
      {loading && <div style={{
          color: "white", paddingTop: "30px"
        }}>
        loading...
      </div>}
    </div>
  );
};

export default DiamondGame;
